/* 布局 */
//前台
import Layout from "@views/layout";

const topicmonographapplyRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "topicmonographapply",
            name: "TOPICMONOGRAPHAPPLY",
            meta: {
                title: "专刊征稿申请管理",
                sort: 1,
            },
            component: () => import("@views/business/topicmonographapply/index.vue"),
            redirect: {
                name: "TOPICMONOGRAPHAPPLY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPICMONOGRAPHAPPLY_LIST",
                    meta: {
                        title: "专刊征稿申请管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/topicmonographapply/list.vue"),
                },
                                                {
                    path: "edit",
                    name: "TOPICMONOGRAPHAPPLY_EDIT",
                    meta: {
                        title: "编辑话题专刊-征稿申请",
                        parentPath: '/business/topicmonographapply/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicmonographapply/form.vue"),
                },
                                        ],
    },


        ],
};

export default topicmonographapplyRouter;
